import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 12,
    overflow: 'hidden',
  },
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(3, 3, 2),
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1.5),
    top: theme.spacing(1.5),
    color: theme.palette.text.secondary,
  },
  title: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.4,
    paddingRight: theme.spacing(5),
  },
  content: {
    padding: theme.spacing(0, 3, 2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  eventContext: {
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    backgroundColor: 'rgba(0, 35, 75, 0.04)',
  },
  nameField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 9999,
      backgroundColor: theme.palette.common.white,
      minHeight: 44,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
      borderRadius: 9999,
    },
    '& fieldset': {
      borderRadius: 9999,
    },
    '& .MuiOutlinedInput-input': {
      padding: theme.spacing(1.25, 1.5),
      fontSize: '0.875rem',
    },
    '& .MuiInputLabel-outlined': {
      fontSize: '0.875rem',
    },
  },
  audienceSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  audienceLabel: {
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
  },
  audienceOption: {
    margin: 0,
  },
  helperText: {
    marginTop: theme.spacing(1),
  },
  dialogActions: {
    justifyContent: 'flex-end',
    padding: theme.spacing(2, 3, 3),
    margin: 0,
    gap: theme.spacing(1),
  },
  createButton: {
    minWidth: 96,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4, 0),
  },
}))

export default useStyles
